import React from "react";
import classNames from "../../classNames";
import Item from "./Item";

const defaultProps = {
  delta: 2,
};

function Pagination({ className, count, current, onClick }) {
  let visiblePages = 10; // Number of visible pages including ellipses
  const items = [];

  // Don't display pagination if there is only 1 page
  if (count === 1 || count === 0) {
    return null;
  }

  // Edge case: if there are fewer pages than the number of visible pages
  if (count < visiblePages) {
    for (let i = 1; i <= count; i++) {
      items.push(
        <Item
          key={i}
          className={i === current ? "active" : ""}
          onClick={() => onClick(i)}
        >
          {i}
        </Item>
      );
    }
    return (
      <nav>
        <ul className={classNames(className, "pagination pagination-sm m-0")}>
          <Item
            className={current === 1 ? "disabled" : ""}
            onClick={() => onClick(current - 1)}
          >
            <i className="bi bi-chevron-left"></i>
          </Item>
          {items}
          <Item
            className={current === count ? "disabled" : ""}
            onClick={() => onClick(current + 1)}
          >
            <i className="bi bi-chevron-right"></i>
          </Item>
        </ul>
      </nav>
    );
  }

  // Add the first page
  items.push(
    <Item
      key={1}
      className={current === 1 ? "active" : ""}
      onClick={() => onClick(1)}
    >
      1
    </Item>
  );

  // If current page is far enough from the start, add ellipsis after the first page
  if (current > 6) {
    items.push(<Item key="left-ellipsis">...</Item>);
  }

  // Determine the start and end of the visible range
  let start = Math.max(2, current - Math.floor(visiblePages / 2) + 1); // At least 2 (after the first page)
  let end = Math.min(count - 1, current + Math.floor(visiblePages / 2) - 1); // Before the last page

  // Ensure there are always exactly `visiblePages` showing
  if (end - start < visiblePages - 2) {
    if (start === 2) {
      end = Math.min(count - 1, start + visiblePages - 3);
    } else if (end === count - 1) {
      start = Math.max(2, end - visiblePages + 3);
    }
  }

  // Add the range of pages between start and end
  for (let i = start; i <= end; i++) {
    items.push(
      <Item
        key={i}
        className={i === current ? "active" : ""}
        onClick={() => onClick(i)}
      >
        {i}
      </Item>
    );
  }

  // If the current page is far enough from the end, add ellipsis before the last page
  if (current < count - 4) {
    items.push(<Item key="right-ellipsis">...</Item>);
  }

  // Add the last page
  items.push(
    <Item
      key={count}
      className={current === count ? "active" : ""}
      onClick={() => onClick(count)}
    >
      {count}
    </Item>
  );

  return (
    <nav>
      <ul className={classNames(className, "pagination pagination-sm m-0")}>
        <Item
          className={current === 1 ? "disabled" : ""}
          onClick={() => onClick(current - 1)}
        >
          <i className="bi bi-chevron-left"></i>
        </Item>
        {items}
        <Item
          className={current === count ? "disabled" : ""}
          onClick={() => onClick(current + 1)}
        >
          <i className="bi bi-chevron-right"></i>
        </Item>
      </ul>
    </nav>
  );
}

Pagination.defaultProps = defaultProps;
export default Pagination;
